<h2 mat-dialog-title>{{ data.title ?? '' | translate }}</h2>
<mat-dialog-content class="mat-typography">
  <span [class]="data.descriptionClass ?? ''">{{ data.description ?? '' | translate }}</span>
  @if (data.checkboxLabel) {
    <mat-checkbox [(ngModel)]="checkboxChecked">{{ data.checkboxLabel }}</mat-checkbox>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog(false)">
    {{ data.cancelLabel ?? ('COMMON.CANCEL' | translate) }}
  </button>
  <button mat-button (click)="closeDialog(true)" cdkFocusInitial>{{ data.confirmLabel ?? ('COMMON.OK' | translate) }}</button>
</mat-dialog-actions>
